import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  onlineUsers: [],
  deviceStats: {
    mobile: 0,
    desktop: 0,
    tablet: 0,
    unknown: 0,
  },
  visitors: [],
  pagination: {
    currentPage: 1,
    totalPages: 1,
    pageSize: 10,
  },
  isFetching: false,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setOnlineUsers: (state, action) => {
      state.onlineUsers = action.payload;
    },
    setDeviceStats: (state, action) => {
      state.deviceStats = { ...state.deviceStats, ...action.payload };
    },
    setVisitors: (state, action) => {
      state.visitors = action.payload;
    },
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    setIsFetching: (state, action) => {
      state.isFetching = action.payload;
    },
    setStats: (state, action) => {
      state.stats = action.payload;
    },
  },
});

export const {
  setOnlineUsers,
  setDeviceStats,
  setVisitors,
  setPagination,
  setIsFetching,
  setStats,
} = dashboardSlice.actions;

export const selectOnlineUsers = (state) => state.dashboard.onlineUsers;
export const selectDeviceStats = (state) => state.dashboard.deviceStats;
export const selectVisitors = (state) => state.dashboard.visitors;
export const selectPagination = (state) => state.dashboard.pagination;
export const selectIsFetching = (state) => state.dashboard.isFetching;
export const selectDashboardStats = (state) => state.dashboard.stats;

export default dashboardSlice.reducer;
